module.exports = __webpack_public_path__ + "img/y.761cb210.svg";